export { default as Texts } from './Text/Text';
export { default as Title } from './Text/Title';

export { default as Media } from './Media/Media';

export { default as Button } from './Button/Button';

export { default as PageHead } from './PageHead';
